<template>
    <div>
        <div>
            <table class="table-striped table-responsive">
                <thead>
                <tr>
                    <th>Instalación</th>
                    <th>Cliente</th>
                    <th>Numero de Serie</th>
                    <th>Clasificación</th>
                    <th>Documento</th>
                    <th>Fecha realizada</th>
                    <th>Fecha prevista</th>
                    <th>Modelo de Negocio</th>
                    <th>Público Infra</th>
                    <th>Dirección</th>
                    <th>Provincia</th>
                    <th>Población</th>
                    <th>Código Postal</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(detail, installation) in installation_list"
                    :key="installation">
                    <td>{{ detail.installation_code }}</td>
                    <td>{{ detail.client }}</td>
                    <td>{{ detail.serial_numbers ? detail.serial_numbers : '' }}</td>
                    <td>{{ detail.classification }}</td>
                    <td>{{ detail.document_name }}</td>
                    <td>{{ detail.effective_date ? helpers.formatDate(detail.effective_date) : '-' }}</td>
                    <td>{{ detail.expected_date ? helpers.formatDate(detail.expected_date) : '-' }}</td>
                    <td>{{ detail.business_model }}</td>
                    <td>{{ detail.public_infra }}</td>
                    <td>{{ detail.address }}</td>
                    <td>{{ detail.province }}</td>
                    <td>{{ detail.city }}</td>
                    <td>{{ detail.postal_code }}</td>
                </tr>
                </tbody>
            </table>

        </div>
        <div>
            <button class="btn btn-primary" @click="exportToExcel">Exportar a Excel</button>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex"
import helpers from "@/resources/helpers/helpers"
import {createHelpers} from "vuex-map-fields"
import ExcelJS from "exceljs"


const {mapFields} = createHelpers({
    getterType: 'dashboardMetricsVhe/getField',
    mutationType: 'dashboardMetricsVhe/updateField',
})

export default {
    name: "InstallationsDetailsView",
    data() {
        return {
            showRowsResume: false,
            showRowsInstallations: false,
            expandedRows: {},
            activeGroups: [],
            localInstallations: [],
            data: [],

            showLoading: false,
            helpers,
        }
    },
    computed: {
        ...mapState('dashboardMetricsVhe', ['dashboard_metrics']),
        ...mapFields({
            dashboard_metrics: 'dashboard_metrics',
            installation_list: 'installation_list',
        }),
    },
    methods: {

        async exportToExcel() {
            const workbook = new ExcelJS.Workbook()
            const worksheet = workbook.addWorksheet('Instalaciones')

            // Encabezados de columna
            const headers = [
                'Instalación',
                'Cliente',
                'Numero de Serie',
                'Clasificación',
                'Documento',
                'Fecha realizada',
                'Fecha prevista',
                'Modelo de Negocio',
                'Público Infra',
                'Dirección',
                'Provincia',
                'Población',
                'Código Postal'
            ]

            worksheet.addRow(headers)
            // Datos de la tabla
            this.installation_list.forEach(detail => {
                worksheet.addRow([
                    detail.installation_code,
                    detail.client,
                    detail.serial_numbers ? detail.serial_numbers : '-',
                    detail.classification,
                    detail.document_name,
                    detail.effective_date ? this.helpers.formatDate(detail.effective_date) : '-',
                    detail.expected_date ? this.helpers.formatDate(detail.expected_date) : '-',
                    detail.business_model,
                    detail.public_infra,
                    detail.address,
                    detail.province ? detail.province : '-',
                    detail.city,
                    detail.postal_code,
                ])
            })

            const columnWidths = [
                70, 25, 100, 20,20, 20, 35, 45, 55, 30,
            ]

            // Establecer anchos fijos para las columnas
            worksheet.columns.forEach((column, index) => {
                column.width = columnWidths[index]
            })

            // Generar el archivo Excel
            const buffer = await workbook.xlsx.writeBuffer()

            // Crear un Blob para la descarga
            const blob = new Blob([buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})

            // Crear una URL para el Blob
            const url = window.URL.createObjectURL(blob)

            // Crear un enlace de descarga y hacer clic en él
            const a = document.createElement('a')
            a.href = url
            a.download = 'instalaciones.xlsx'
            a.click()

            // Liberar recursos
            window.URL.revokeObjectURL(url)
        }


    },


}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

[dir] .dashboard-metrics {
    font-size: 12px; /* Tamanho de fonte desejado */
}

</style>